import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  passwordLabelBox: {
    margin: '32px 0px 0px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& > p': {
      color: colorSet.gray600
    }
  },
  inputContainer: {
    marginTop: '12px',
    flexWrap: 'nowrap'
  }
}));
